export default "__VITE_ASSET__7400767a__"